import { getZoneFromSite, siteNames } from '@seek/melways-sites';
import { Brand, Product } from '../../types.js';
export default {
    audience: 'https://seek/api/candidate',
    authDomain: 'login.seek.com',
    clientDomain: 'my.jobstreet.com',
    clientId: 'YYR5RkFITfSNEJOQnQOwhfFQ4dRmZBkX',
    environment: 'prod',
    redirectPath: '/oauth/callback/',
    realm: 'Username-Password-Authentication',
    brand: Brand.JOBSTREET,
    contactUs: {
        en: 'https://my.jobstreet.com/contact-us/',
    },
    siteName: siteNames.candidate.jobstreet.my,
    zone: getZoneFromSite(siteNames.candidate.jobstreet.my),
    product: Product.SEEK,
};
//# sourceMappingURL=my_jobstreet_com.js.map